import { createContext, MouseEvent } from 'react'
import { OpportunityCandidateStatus } from 'src/constants/opportunity/enums'
import { OpportunityCandidate } from 'src/interfaces/opportunity'

export interface ICandidatePoolTableContext {
  refreshCandidates(): void

  selectedTab: OpportunityCandidateStatus
  selectedCandidates: Array<OpportunityCandidate>

  /** Opens the offer modal for an explicit set, so a row action cannot leak into the next batch one. */
  openOfferForCandidates(candidates: Array<OpportunityCandidate>): void
  archiveCandidates(candidateIds: Array<string>): void
  unarchiveCandidates(candidateIds: Array<string>): void

  rowAnchor: null | HTMLElement
  candidateToAction: OpportunityCandidate | null
  openCandidateItemAction(
    event: MouseEvent<HTMLButtonElement>,
    candidate: OpportunityCandidate,
  ): void
  closeCandidateItemAction(): void
  clearCandidateToAction(): void

  batchAnchor: null | HTMLElement
  openBatchAction(event: MouseEvent<HTMLButtonElement>): void
  closeBatchAction(): void
}

export const CandidatePoolTableContext = createContext<ICandidatePoolTableContext>({
  refreshCandidates: () => {},

  selectedTab: OpportunityCandidateStatus.New,
  selectedCandidates: [],

  openOfferForCandidates: () => {},
  archiveCandidates: () => {},
  unarchiveCandidates: () => {},

  rowAnchor: null,
  candidateToAction: null,
  openCandidateItemAction: () => {},
  closeCandidateItemAction: () => {},
  clearCandidateToAction: () => {},

  batchAnchor: null,
  openBatchAction: () => {},
  closeBatchAction: () => {},
})
